export { default as android } from './android';
import * as general_1 from './general';
export { general_1 as general };
export { default as ios } from './ios';
